import { useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const JobAuthor = ({ author }: { author: string }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const authorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = authorRef.current;
    if (!element) return;

    const observer = new ResizeObserver(() => {
      const isTruncated = element.scrollWidth > element.clientWidth;
      setShowTooltip(isTruncated);
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [author]);

  return (
    <div
      ref={authorRef}
      className="text-sm leading-5 text-gray-600 flex-4 min-w-0 content-start items-start justify-start text-left truncate"
    >
      {showTooltip ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>{author}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{author}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        author
      )}
    </div>
  );
};
